export { default as useRatings } from './use-ratings';
